module.exports = __webpack_public_path__ + "static/media/hall-PB.5b9fac2d.svg";